import {
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import React from "react";
import { useState } from "react";

const drawerWidth = "15%";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const StyledList = styled("List")(({ theme }) => ({
  "& .MuiTypography-body1": {
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px !important",
    },
    [theme.breakpoints.up("xs")]: {
      fontSize: "14px !important",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px !important",
    },
  },
  "& .MuiListItemButton-root": {
    padding: theme.spacing(1),
  },
}));

export const SideBar = (props) => {
  const theme = useTheme();
  const { open, categories, onDrawerClose, onOptionClick, selectedCat } = props;
  const [cats, setCats] = useState(categories);
  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          paddingX: "15px",
        },
        display: {
          xs: "none",
          sm: "none",
          md: "none",
          lg: "block",
          xl: "block",
        },
      }}
      variant="persistent"
      anchor="left"
      open={open}
      position="fixed"
    >
      <DrawerHeader>
        {/* <IconButton onClick={() => onDrawerClose()}>
          {theme.direction === "ltr" ? (
            <ChevronLeftIcon sx={{ color: "#fff", fontSize: "2rem" }} />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton> */}
      </DrawerHeader>
      <Divider />
      <StyledList>
        {cats.map((cat, index) => (
          <ListItem
            key={cat.id}
            sx={{
              color: ` ${selectedCat === cat.id ? "#972020" : "#433f3f"}`,
              fontSize: "0.8rem",
              borderRadius: "5px",
              margin: "10px 0px",
            }}
            disablePadding
            component={Paper}
            elevation={3}
          >
            <ListItemButton onClick={() => onOptionClick(cat.id)}>
              <ListItemText primary={cat.categoryDescription} />
            </ListItemButton>
          </ListItem>
        ))}
      </StyledList>
    </Drawer>
  );
};
